<template>
  <div>
    <router-view></router-view>

    <div class="d-block d-sm-block d-md-none">
      <SwipeUpCart></SwipeUpCart>

      <FooterMobile :show_details="false"/>
    </div>

  </div>
</template>

<script>
import HomeService from '@/services/home.service'
import SwipeUpCart from '@/components/store/mobile/SwipeUpCart'
import FooterMobile from '@/components/store/mobile/FooterMobile'

export default {
  components: {
    SwipeUpCart,
    FooterMobile
  },
  data() {
    return {}
  },
  methods: {
    async getUser() {
			try {
				const { data:res } = await HomeService.me()
				if (res.success) {
          this.$store.dispatch('setUser', res.data)
        }
        this.$store.dispatch('setCart')
			} catch (error) {
				this.$store.dispatch('setCart')
			}
    }
  },
  created() {
    this.getUser()
	}
}
</script>

<style>
.container-cart-payment {
  width: 100%;
  height: 100%;
}
.container-payment {
  margin-bottom: 50%;
}
</style>
